import type { InstanceClosedEvent } from '../../../services/playjector/interfaces/IPlayjectorService';

/**
 * Sink for `processInstanceClosedMSG` notifications. Structural subset of
 * `MatchLifecycleManager` — keeps this handler testable without the
 * coordinator graph.
 */
export type InstanceClosedHandler = {
  handleInstanceClosed(event: InstanceClosedEvent): void;
};

/**
 * Android multi-instance (host Phase 4): route per-instance closed
 * notifications into the match lifecycle, which transitions the instance to
 * `failed`, ends any match on it, and notifies the recovery policy.
 *
 * One file, one message. The production wiring lives in `coordinators/init.ts`,
 * which subscribes the handler built here to
 * `PlayjectorService.onInstanceClosed` (the service taps the
 * `process/instanceClosed` mainMessage channel and gates forwarding on the
 * registered streamId). Unknown/torn-down instances are ignored inside the
 * sink, so this handler never throws.
 */
export const createInstanceClosedHandler = (
  getManager: () => InstanceClosedHandler,
) => {
  return (event: InstanceClosedEvent): void => {
    getManager().handleInstanceClosed(event);
  };
};
